export default __webpack_public_path__ + "static/media/alert.3d0beecd.svg";